import { Children } from 'react';

const getChildrenProps = (children) => {
    const childProps = {};
    Children.map(children, (child) => {
        const childType = child && child.type && child.type.displayName
            ? child.type.displayName
            : '';
        /* istanbul ignore else */
        if (childType === 'TitleLockupEyebrow') {
            childProps.eyebrowProps = child.props;
        }
        /* istanbul ignore else */
        if (childType === 'TitleLockupSubtitle') {
            childProps.subtitleProps = child.props;
        }
        /* istanbul ignore else */
        if (childType === 'TitleLockupTitle') {
            childProps.titleProps = child.props;
        }
    });
    return childProps;
};

export { getChildrenProps };
